import type { StateCreator } from 'zustand';
import { logError } from 'setup/logger/logError';
import { issueClient } from 'shared/domain/issue/issueClient';
import type { IssueListAddress, IssuesQuery } from 'shared/domain/issue/issueQuery';
import { createLatestRead } from 'store/latestRead';

/** The grid's issues in order, for the previous / next navigation of the issue view. */
export type IssueNavigationSlice = {
  issueIdList: IssueListAddress[];
  issueIdListLoading: boolean;
  /** Reads the navigation list for the query; only the latest read is applied. */
  loadIssueIdList: (query: IssuesQuery) => Promise<void>;
  resetIssueNavigation: () => void;
};

const initialState: Pick<IssueNavigationSlice, 'issueIdList' | 'issueIdListLoading'> = {
  issueIdList: [],
  issueIdListLoading: true,
};

export const createIssueNavigationSlice: StateCreator<IssueNavigationSlice> = (set) => {
  const latestRead = createLatestRead();
  return {
    ...initialState,
    loadIssueIdList: (query) => {
      set({ issueIdListLoading: true });
      return latestRead.run(() => issueClient.getFilteredIdList(query), {
        onResult: (issueIdList) => set({ issueIdList, issueIdListLoading: false }),
        onError: (error) => {
          logError('Error while reading the issue list for navigation', error);
          set({ issueIdListLoading: false });
        },
      });
    },
    resetIssueNavigation: () => {
      latestRead.cancel();
      set(initialState);
    },
  };
};
